var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartContainer",staticClass:"donut-chart-container"},[(_vm.data.length === 0)?_c('div',{staticClass:"no-data"},[_vm._t("no-data",function(){return [_vm._v("No data available")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }